import React from 'react'
import './index.less'
import { Toast } from 'antd-mobile'
import request from '../../assets/js/request'
import { isEmpty, device, validation, getQueryVariable, getParams } from './../../assets/js/utils'

// 图片加载
import user from '../../assets/images/pingAnCard/user.png'
import phone from '../../assets/images/pingAnCard/phone.png'
import rule from '../../assets/images/pingAnCard/rule.png'

import button from '../../assets/images/pingAnCard/button.png'

const modalList = [
    [{ id: 1, str: '活动期间，用户可参与超百家大牌商家（京东到家、每日优鲜、便利蜂等）天天88折支付优惠活动，通过微信绑定使用平安银行国美联名信用卡支付即有机会享支付88折优惠，品牌商家持续更新，具体商家以平安天天88折活动公告为准，参与规则以各商家88折优惠活动规则为准。' }],
    [
        {
            id: 1,
            str: <div>活动内容<br/>即日起至2021年4月30日（含当日），国美联名卡持卡人可以在国美APP内选择购买冰箱、洗衣机、油烟机、灶具、空调5大品类家电，通过国美APP支付收银台绑定联名卡支付，享支付价格98折上折优惠（国美APP内指定的特价机型除外）。详情以国美APP公告为准。</div>
        }, {
            id: 2,
            str: <div>活动时间<br/>即日起至2021年4月30日（含）</div>
        }, {
            id: 3,
            str: <div>活动对象<br/>平安银行国美联名卡持卡人</div>
        }, {
            id: 4,
            str: <div>
                使用流程<br/>
                STEP1.下载并打开国美APP，选择所购买的优惠商品并提交支付<br/>
                STEP2.收银台选择“使用新卡快捷支付”，选择平安银行/信用卡，成功绑定国美联名卡<br/>
                STEP3.选择国美联名卡支付<br/>
                STEP4.支付完成享受优惠<br/>
                温馨提示：本次活动规则如有调整或变更以平安口袋银行APP内公告为准。</div>
        }
    ]
]
export default class PingAnCard extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            transmitValue: {
                name: '',
                mobile: '',
                channel: 'WXHZF',
                inviterMobile: '',
                ...getQueryVariable()
            },
            showMask: false,
            list: [],
            modalContent: []
        }
    }

    componentDidMount=() => {
        this.init()
    }

    init=() => {
        request.get('/gateway/v3/config/advertisement/pinganCredit').then(res => {
            this.setState({ list: [...res.data] })
        })
    }

    /**
     * @description 活动规则
     */
    handleRuleClick=(url) => {
        window.location.href = url
    }

    /**
     * @description 操作提交按钮
     */
    handleSumbit () {
        const data = this.valid()
        if (data.code) return Toast.info(data.msg, 1)
        // 调用接口
        this.pingan_gateway_applypIndex()
    }

    componentDidMount () {
        const loading = document.querySelector('.page-loading')
        loading.style.opacity = 0
        loading.style.zIndex = -1
        loading.style.display = 'none'
        const params = getParams()
        const { transmitValue } = this.state
        transmitValue.inviterMobile = params.inviterMobile
        this.setState({ transmitValue: transmitValue })
    }

    /**
     * @description 提交接口
     */
    pingan_gateway_applypIndex () {
        const url = '/gateway/v1/pingan/ca/applypIndex'
        const headers = {
            'Content-Type': 'application/json;charset=UTF-8'
        }
        request.post(url, this.state.transmitValue, { headers: headers }).then(res => {
            const { data, code, msg } = res
            if (code === '200') {
                const time = new Date().getTime() + Math.random()
                window.location.href = `${data}&timestamp=${time}`
            } else {
                Toast.info(msg, 1)
            }
        }).catch(err => {
            console.log(err)
        })
    }

    /**
     * @description 表单验证接口
     */
    valid () {
        const {
            transmitValue: {
                name,
                mobile
                // inviterMobile
            }
        } = this.state
        if (isEmpty(name)) return { code: 1, msg: '姓名不能为空' }
        if (validation.name.test(name)) return { code: 1, msg: '请输入正确的姓名' }
        if (isEmpty(mobile)) return { code: 1, msg: '手机号不能为空' }
        if (!validation.mobile.test(mobile)) return { code: 1, msg: '请输入正确的手机号' }
        // if (isEmpty(inviterMobile)) return { code: 1, msg: '推荐人手机号不能为空' }
        // if (!validation.mobile.test(inviterMobile)) return { code: 1, msg: '请输入正确的推荐人手机号' }
        return { code: 0, msg: '成功' }
    }

    /**
     * @description 失去焦点进行处理
     */
    handleBlurPosition () {
        // 兼容 IOS12 + V6.7.4+
        const wechatInfo = window.navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)
        const IOS = device.isIOS

        if (!wechatInfo && !IOS) return
        const wechatVersion = wechatInfo ? wechatInfo[1] : ''
        const version = (navigator.appVersion).match(/OS (\d+)(\d+)?(\d+)?/)
        if (+wechatVersion.replace(/./g, '') >= 674 && version && +version[1] >= 12) {
            setTimeout(() => {
                window.scrollTo(0, Math.max(document.body.clientHeight, document.documentElement.clientHeight))
            })
        }
    }

    hanldeNameChange (e) {
        const { transmitValue } = this.state
        transmitValue.name = e.target.value
        this.setState({ transmitValue: transmitValue })
    }

    hanldePhoneChange (e) {
        const { transmitValue } = this.state
        transmitValue.mobile = e.target.value
        this.setState({ transmitValue: transmitValue })
    }

    openMask=(is8898) => {
        const modalContent = is8898 === '88' ? modalList[0] : modalList[1]
        this.setState({ modalContent }, () => {
            this.setState({ showMask: true })
        })
    }

    closeMask=() => {
        this.setState({ showMask: false })
    }

    hanldeInviterPhoneChange (e) {
        const { transmitValue } = this.state
        transmitValue.inviterMobile = e.target.value
        this.setState({ transmitValue: transmitValue })
    }

    render () {
        const { transmitValue: { inviterMobile }, list, modalContent, showMask } = this.state
        const home = list[0]
        const bg = list[1]
        const imgList = list.slice(2)
        return (
            <div className="ping-an-page">
                <div className="popupmask" style={{ display: showMask ? 'block' : 'none' }}>
                    <div className="content">
                        <div className="closeBtn" onClick={this.closeMask.bind(this)}>
                        </div>
                        <img src="https://cdn.sdb.com.cn/app_upload/brop-mop/image/12d53761236845dab6e5e4da8f2c653d_567_31.png" />
                        {
                            modalContent && modalContent.map(items => (
                                <div className="text" key={items.id}>
                                    <span className="icon"></span>
                                    {items.str}
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="ping-an-page-box">
                    {
                        home && (
                            <div className="layout-top" style={{
                                background: `url(${home.pictureList[0].imageUrl}) no-repeat`,
                                backgroundSize: 'cover'
                            }}>
                                <img className="layout-icon" src={home.pictureList[0].imageUrl} style={{ visibility: 'hidden' }}/>
                                <img className="layout-rule" onClick={() => this.handleRuleClick(home.pictureList[0].url)} src={rule} />
                            </div>

                        )
                    }
                    <div className="form" style={bg && { background: `url(${bg.pictureList[0].imageUrl}) no-repeat 100%` }}>
                        <div className="form-icon">
                            <div className="form-items">
                                <div className="form-items-box">
                                    <img className="form-items-icon" src={phone} />
                                    <input type="tel"
                                        onChange={this.hanldeInviterPhoneChange.bind(this)}
                                        onBlur={this.handleBlurPosition.bind(this)}
                                        value={inviterMobile}
                                        maxLength="11" className="form-items-input" placeholder="请输入推荐人手机号"/>
                                </div>
                            </div>
                            <div className="form-items">
                                <div className="form-items-box">
                                    <img className="form-items-icon" src={user} />
                                    <input type="text"
                                        onChange={this.hanldeNameChange.bind(this)}
                                        onBlur={this.handleBlurPosition.bind(this)}
                                        maxLength="30" className="form-items-input" placeholder="请输入姓名"/>
                                </div>
                            </div>
                            <div className="form-items">
                                <div className="form-items-box">
                                    <img className="form-items-icon" src={phone} />
                                    <input type="tel"
                                        onChange={this.hanldePhoneChange.bind(this)}
                                        onBlur={this.handleBlurPosition.bind(this)}
                                        maxLength="11" className="form-items-input" placeholder="请输入手机号"/>
                                </div>
                            </div>
                            <img
                                className="form-submit-icon"
                                onClick={this.handleSumbit.bind(this)} src={button} />
                        </div>
                    </div>
                    {
                        imgList.map((items, index) => {
                            const src = items.pictureList[0].imageUrl
                            const is8898 = /(98)|(88)/g.exec(items.pictureList[0].title)
                            return src ? (
                                <div
                                    className="images"
                                    style={{ background: `url(${src}) no-repeat`, backgroundSize: 'cover' }}
                                    onClick={ () => { if (is8898 && index >= imgList.length - 3) this.openMask(is8898[0]) }}
                                    key={items.id}
                                >
                                    <img className="layout-icon" src={src} style={{ visibility: 'hidden' }}/>
                                </div>
                            ) : ''
                        })
                    }
                </div>
            </div>
        )
    }
}
